import { TrialProgressCard } from 'assets/js/pages/contacts/data-hygiene/TrialProgressCard';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const PhoneNumbersTrialProgressCard = () => {
    const { dataHygiene, isCurrentlyOnFreeTrial } = useCurrentAccount();
    const freeTrialScans = dataHygiene.free_trial_scans;

    if (!isCurrentlyOnFreeTrial || !freeTrialScans) {
        return null;
    }

    const total = freeTrialScans.max_count;
    const progress = freeTrialScans.phone_numbers.deliverability.count;

    return <TrialProgressCard progress={progress} total={total} visibleTotal={total} />;
};

export { PhoneNumbersTrialProgressCard };
